import { Link } from "react-router-dom";
import moment from "moment";

import {
  getPaymentStatusIndicator,
  truncateStringWithEllipsis,
} from "../../../utils";
import {
  Badge,
  CopyButton,
  CurrencyDisplay,
  StructuredList,
} from "../../../components";
import { appConfig } from "../../../configs";
import { IViewTransactionListItem } from "../../../interfaces-and-types";

export const PartialPaymentsContainedView = ({
  partialPaymentTransactions,
}: {
  partialPaymentTransactions: IViewTransactionListItem[];
}) => {
  const containsLoansDeductions = partialPaymentTransactions.find(
    (pp) =>
      pp.total_standing_order_deductions > 0 ||
      pp.total_affiliate_deductions > 0
  );
  return (
    <StructuredList
      headers={
        <div className="cds--structured-list-row cds--structured-list-row--header-row">
          <div className="cds--structured-list-th pr-5 align-text--center">
            PAID
          </div>
          <div className="cds--structured-list-th pr-5 align-text--right">
            AMOUNT SETTLED
          </div>
          {!containsLoansDeductions ? null : (
            <div className="cds--structured-list-th pr-5 align-text--right">
              DEDUCTIONS
            </div>
          )}
          <div className="cds--structured-list-th">STATUS</div>
          <div className="cds--structured-list-th">REFERENCE</div>
          <div className="cds--structured-list-th">PROVIDER</div>
          <div className="cds--structured-list-th">PAID ON</div>
        </div>
      }
      {...{
        rows: partialPaymentTransactions.map((transaction) => {
          const statusIndicator = getPaymentStatusIndicator(transaction);

          return (
            <Link
              to={`/payments/${transaction.id}/details`}
              state={{
                transactionToViewDetails: transaction,
              }}
              className="cds--structured-list-tbody"
            >
              <div className="cds--structured-list-row">
                <div className="cds--structured-list-td align-text--right">
                  <CurrencyDisplay
                    amount={transaction.amount_paid}
                    currencyOrSymbol={transaction.currency}
                    amountFontSize={16}
                    symbolFontSize={12}
                    amountClassName={""}
                    symbolClassName={""}
                  />
                </div>

                <div className="cds--structured-list-td align-text--right">
                  <CurrencyDisplay
                    amount={transaction.amount_settled ?? 0}
                    currencyOrSymbol={transaction.currency}
                    amountFontSize={16}
                    symbolFontSize={12}
                    amountClassName={""}
                    symbolClassName={""}
                  />
                </div>

                {!containsLoansDeductions ? null : (
                  <div className="cds--structured-list-td align-text--right">
                    <CurrencyDisplay
                      amount={
                        transaction.total_standing_order_deductions +
                        transaction.total_affiliate_deductions
                      }
                      currencyOrSymbol={transaction.currency}
                      amountFontSize={16}
                      symbolFontSize={12}
                      amountClassName={""}
                      symbolClassName={""}
                    />
                  </div>
                )}

                <div className="cds--structured-list-td">
                  <Badge
                    text={statusIndicator.statusText}
                    statusColor={statusIndicator.statusType}
                    hideIndicator
                    className=""
                  />
                </div>
                <div
                  className="cds--structured-list-td"
                  title={transaction.tx_ref}
                >
                  <div className="flex-container justify-content--start align-items--center no-wrap">
                    <div className="transaction-id-text modal-header--title">
                      <span title={transaction.tx_ref}>
                        {truncateStringWithEllipsis(transaction.tx_ref, 15)}
                      </span>
                    </div>
                    <div className="copy-button--container ml-3">
                      <CopyButton
                        name="copy-reference-button"
                        stringToCopy={transaction.tx_ref}
                        iconDescription="copy reference"
                        className="copy-btn"
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="cds--structured-list-td"
                  title={transaction.gateway_code}
                >
                  <span className="gateway-display">
                    {!transaction.gateway_code ? (
                      "-"
                    ) : (
                      <div className="flex-container pr-5 justify-content--center">
                        <img
                          alt="gateway"
                          src={`/gateway-logos/${transaction.gateway_code}-icon.svg`}
                          className="gateway-icon--small"
                          title={transaction.gateway_code}
                        />
                      </div>
                    )}
                  </span>
                </div>
                <div className="cds--structured-list-td">
                  {moment(transaction.paid_at).format(appConfig.dateTimeFormat)}
                </div>
              </div>
            </Link>
          );
        }),
      }}
    />
  );
};
